/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InspectionCategoryResponse
 */
export interface InspectionCategoryResponse {
    /**
     * 
     * @type {number}
     * @memberof InspectionCategoryResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionCategoryResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InspectionCategoryResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the InspectionCategoryResponse interface.
 */
export function instanceOfInspectionCategoryResponse(value: object): value is InspectionCategoryResponse {
    return true;
}

export function InspectionCategoryResponseFromJSON(json: any): InspectionCategoryResponse {
    return InspectionCategoryResponseFromJSONTyped(json, false);
}

export function InspectionCategoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionCategoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function InspectionCategoryResponseToJSON(json: any): InspectionCategoryResponse {
    return InspectionCategoryResponseToJSONTyped(json, false);
}

export function InspectionCategoryResponseToJSONTyped(value?: InspectionCategoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

